/**
 * @date: 12/3/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useEffect, useState} from 'react';
import clsx from 'clsx';

import './UserDashboard.css';
import ShowMessage from "../utils/show-message";
import {Link, Route, Routes} from "react-router-dom";
import UserMenuList from "./UserMenuList";
import UserHomeContent from "./UserHomeContent";
import Copyright from "../utils/Copyright";
import {PortalUrl} from "../utils/portal-urls";
import OrganizationsHome from "../Organization/OrganizationsHome";
import OrganizationUsersHome from "../users/OrganizationUsersHome";
import {
    AppBar,
    Backdrop,
    Button,
    CircularProgress,
    CssBaseline,
    Divider,
    Drawer,
    IconButton,
    List,
    Toolbar
} from "@mui/material";
import {makeStyles, withStyles} from '@mui/styles'
import MenuIcon from '@mui/icons-material/Menu';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import DnsIcon from '@mui/icons-material/Dns';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Badge from '@mui/material/Badge'
import NpiNewImportTask from "../Npi/NpiNewImportTask";
import NpiPageHome from "../Npi/NpiPageHome";
import ExternalSourceManagementHome from "../ExternalSourceManagement/ExternalSourceManagementHome";
import NuccSpecialtyValueSetPageHome from "../NuccSpecialtyValueSet/NuccSpecialtyValueSetPageHome";
import NuccSpecialtyValueSetNewImportTask from "../NuccSpecialtyValueSet/NuccSpecialtyValueSetNewImportTask";
import ValidationRulesHome from "../ValidationRules/ValidationRulesHome";
import ContributionHome from "../Contributions/ContributionHome";
import ServDescriptionHome from "../ServDescription/ServDescriptionHome";
import AuditLogsHome from "../AuditLogs/AuditLogsHome";
import ServDescriptionNewImportTask from "../ServDescription/ServDescriptionNewImportTask";
import PublishedHome from "../Published/PublishedHome";
import BatchProcess from "../Task/BatchProcess";
import HispsHome from "../Hisps/HispsHome";
import SinglePublication from "../Published/SinglePublication";
import AdHocReportHome from "../Published/AdHocReportHome";
import SuffixHome from "../Suffix/SuffixHome";
import SuffixNewImportTask from "../Suffix/SuffixNewImportTask";
import OrgTypeHome from "../OrgType/OrgTypeHome";
import OrgTypeNewImportTask from "../OrgType/OrgTypeNewImportTask";
import TerminologyHome from "../Terminology/TerminologyHome";
import TerminologyNewImportTask from "../Terminology/TerminologyNewImportTask";

const drawerWidth = 300;

const ButtonNoShadow = withStyles({
    root: {
        boxShadow: 'none',
        border: 'none',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#3f51b5'
        }
    },
})(Button)

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    link: {
        color: 'white',
    },
    copyRight: {
        position: 'fixed',
        bottom: 10, left: 50
    },
    logoWrapper: {

        '& img': {width: 192, marginRight: 32}
    },
    toolbarActionWrapper: {
        position: "absolute",
        right: 10
    },
    portalStatusButton: {},
    portalStatusButtonBadge: {}
}));

const MenuItemBadge = withStyles((theme) => ({
    badge: {
        right: -6,
        top: -10,
        padding: '0 4px',
    },
}))(Badge);


export default function UserDashboard(props) {
    console.log('UserDashboard', props);
    const account = props.account;
    const onServerInfoUpdated = props.onServerInfoUpdated;
    const appVersion = account && account.server && account.server.version || "";
    const appEnv = account && account.server && account.server.env || "";
    const signOut = props.signOut;
    const classes = useStyles();


    const [msg, setMsg] = useState({});
    const [showBatchBar, setShowBatchBar] = useState(false);

    const [open, setOpen] = useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const [loading, setLoading] = useState(false);

    const [showContextTransactioinDialog, setShowContextTransactioinDialog] = useState(false);
    const [activeBatchProcess, setActiveBatchProcess] = useState(null);
    const [contextIgTransactions, setContextIgTransactions] = useState([]);
    useEffect(() => {
        if (account) {
            setContextIgTransactions(account.contextIgTransactions || []);
            setActiveBatchProcess(account.batchProcess || null);
        }
    }, [account]);
    const handleProcessSubscriptionRequestCompleted = (messageId) => {
        if (contextIgTransactions && contextIgTransactions.length > 0) {
            const list = [];

            for (var i = 0; i < contextIgTransactions.length; i++) {
                var tran = contextIgTransactions[i];
                if (tran.messageId !== messageId) {
                    list.push(tran);
                }
            }
            if (list.length < contextIgTransactions.length) {
                setContextIgTransactions(list);
            }
        }
    }
    const handleCancelledBatchProcess = () => {
        setActiveBatchProcess(null);
    }



    return (
        <div className={`${classes.root}  dashboard-wrapper header-wrapper `}>
            <CssBaseline/>
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar
                    // className={`${classes.toolbar} ${account && isMasterAdmin(account.user) ? 'header-masterAdminToolbar' : 'header-toolbar'}`}>
                    className={`${classes.toolbar} 'header-toolbar'`}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                        size="large">
                        <MenuIcon/>
                    </IconButton>
                    {/*<div className='logo-wrapper'>*/}
                    {/*    <img src={require('../images/dt-logo.png')} height={40} />*/}
                    {/*</div>*/}
                    <div className='prod-name'>
                        {appEnv && appEnv !== "PROD" && <Badge badgeContent={appEnv} color='secondary' children={<span> DirectTrust Directory Admin Portal </span>}/>}

                        {appEnv && appEnv === "PROD" && <span>MaxSignatures Admin Portal </span>}
                        {appVersion && <span className='app-version'>v{appVersion}</span>}
                    </div>

                    {/*<Typography component="h1"  variant="h6" align={"left"} color="inherit" noWrap className={classes.title}>*/}
                    {/*    MaxMD Certificate Portal*/}
                    {/*</Typography>*/}
                    <div className={classes.toolbarActionWrapper}>
                        {contextIgTransactions && contextIgTransactions.length > 0 && <IconButton
                            color="inherit"
                            className={classes.portalStatusButton}
                            onClick={() => setShowContextTransactioinDialog(true)}
                            size="large">
                            <LibraryAddCheckIcon/> <MenuItemBadge badgeContent={contextIgTransactions.length}
                                                                  color="secondary"
                                                                  className={classes.portalStatusButtonBadge}/>
                        </IconButton>}
                        {/*{account && account.contextIgTransactions && account.contextIgTransactions.length > 0 && <IconButton color="inherit" className={classes.portalStatusButton}*/}
                        {/*            onClick={() => setShowContextTransactioinDialog(true)}>*/}
                        {/*    <LibraryAddCheckIcon/> <MenuItemBadge badgeContent={account.contextIgTransactions.length} color="secondary" className={classes.portalStatusButtonBadge}/>*/}
                        {/*</IconButton> }*/}

                        {activeBatchProcess && <IconButton
                            color="inherit"
                            className={classes.portalStatusButton}
                            onClick={() => setShowBatchBar(!showBatchBar)}
                            size="large">
                            {/*<DnsOutlinedIcon />*/}
                            <DnsIcon/>
                            <MenuItemBadge badgeContent={1} color="secondary"
                                           className={classes.portalStatusButtonBadge}/>
                        </IconButton>}
                    </div>


                </Toolbar>
            </AppBar>


            <Drawer
                variant="permanent" width={drawerWidth}
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <div className={classes.logoWrapper}>
                        <Link to={"/"}>
                            <img src={require('../images/dt-logo.png')?.default} alt={'dt-logo'}/>
                        </Link>
                    </div>
                    <IconButton onClick={handleDrawerClose} size="large">
                        <ChevronLeftIcon/>
                    </IconButton>
                </div>
                <Divider/>
                <List>
                    <UserMenuList signOut={signOut} account={account}/>
                </List>
                {/*<Divider />*/}
                <div className={classes.copyRight}>
                    <Copyright/>
                </div>
            </Drawer>


            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>

                {/*{activeBatchProcess && showBatchBar &&*/}
                {/*        <BatchProgressBar account={account} id={activeBatchProcess.id} name={activeBatchProcess.name} initBatch={activeBatchProcess} handleCancelledBatchProcess={handleCancelledBatchProcess}*/}
                {/*              handleCompleted={() => console.log('batch completed')} handleFailed={(batch) => setMsg({error: batch && batch.description || "Failed to run the process"})} />}*/}


                <ShowMessage msg={msg}/>

                <Routes>

                    {/*react router version 6 */}
                    <Route path={PortalUrl.Organization.Home.pattern}
                           element={<OrganizationsHome account={account} onServerInfoUpdated={onServerInfoUpdated}/>}/>
                    <Route path={PortalUrl.Users.Home.pattern} element={<OrganizationUsersHome account={account}
                                                                                               onServerInfoUpdated={onServerInfoUpdated}/>}>
                        <Route path={PortalUrl.Users.Home.pattern_with_orgId}
                               element={<OrganizationUsersHome account={account}
                                                               onServerInfoUpdated={onServerInfoUpdated}/>}/>
                    </Route>

                    <Route path={PortalUrl.ExternalSource.Home.pattern} element={<ExternalSourceManagementHome />} />

                    <Route path={PortalUrl.ExternalSource.NPPESNPI.pattern_home} element={<NpiPageHome account={account} onServerInfoUpdated={onServerInfoUpdated} activeBatchProcess={activeBatchProcess} handleCancelledBatchProcess={handleCancelledBatchProcess}/>} />
                    <Route path={PortalUrl.ExternalSource.NPPESNPI.pattern_new_task} element={<NpiNewImportTask account={account} handleCancelledBatchProcess={handleCancelledBatchProcess} onServerInfoUpdated={onServerInfoUpdated}/>}/>

                    <Route path={PortalUrl.ExternalSource.NUCCSpecialty.pattern_home} element={<NuccSpecialtyValueSetPageHome />} />
                    <Route path={PortalUrl.ExternalSource.NUCCSpecialty.pattern_new_task} element={<NuccSpecialtyValueSetNewImportTask  />} />
                    <Route path={PortalUrl.ExternalSource.ServDescription.pattern_home} element={<ServDescriptionHome/>} />
                    <Route path={PortalUrl.ExternalSource.ServDescription.pattern_new_task} element={<ServDescriptionNewImportTask />} />
                    <Route path={PortalUrl.ExternalSource.Suffix.pattern_home} element={<SuffixHome />} />
                    <Route path={PortalUrl.ExternalSource.Suffix.pattern_new_task} element={<SuffixNewImportTask />} />
                    <Route path={PortalUrl.ExternalSource.OrgType.pattern_home} element={<OrgTypeHome />} />
                    <Route path={PortalUrl.ExternalSource.OrgType.pattern_new_task} element={<OrgTypeNewImportTask />} />
                    {/* Amendment #1 A5 — one route pair for every value set in utils/terminology.js.
                        The new-task path must precede the home path or ":name" swallows it. */}
                    <Route path={PortalUrl.ExternalSource.Terminology.pattern_new_task} element={<TerminologyNewImportTask />} />
                    <Route path={PortalUrl.ExternalSource.Terminology.pattern_home} element={<TerminologyHome />} />
                    <Route path={PortalUrl.ValidationRules.Home.pattern} element={<ValidationRulesHome />} />
                    {/*<Route path={"/published/:id/"} element={<SinglePublication u="i"  /> } />*/}
                    <Route path={PortalUrl.Published.Home.pattern} element={<PublishedHome />} />
                    <Route path={PortalUrl.Published.Publication.pattern} element={<SinglePublication />} />
                    <Route path={PortalUrl.Published.HocReport.pattern} element={<AdHocReportHome />} />
                    <Route path={PortalUrl.Contributions.Home.pattern} element={<ContributionHome />} />
                    <Route path={PortalUrl.Contributions.HocReport.pattern} element={<AdHocReportHome />} />
                    <Route path={PortalUrl.AuditLogs.Home.pattern} element={<AuditLogsHome/>}/>
                    <Route path={PortalUrl.Hisps.Home.pattern} element={<HispsHome />} />
                    {/*<Route path={"/task"} render={props => <BatchProcess {...props} /> }/>*/}
                    <Route path={PortalUrl.Batch.ViewTask.pattern} element={<BatchProcess  /> } />

                    <Route path={PortalUrl.Home} element={<UserHomeContent account={account} onServerInfoUpdated={onServerInfoUpdated}/>}/>

                </Routes>

                <br/>
                <br/>
                <br/>

            </main>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </div>
    );
}
